<template>
  <AppBanner>
    <template #prepend>
      <BoltIcon />
    </template>
    {{ $tt('priority.fast_processing') }}: 
    <PriceSpan operand="+" :price="form.product.urgencies!.find(u => u.speed == form.urgency)!.fee" strong />
  </AppBanner>
</template>

<script setup lang="ts">
import type { VisaForm } from '~/types';

defineProps<{
  form: VisaForm;
}>();
</script>